import React from "react";
import ReactDOM from "react-dom/client";
import { UIProvider } from "./contexts/UIContext";
import { Auth0Provider } from "@auth0/auth0-react";
import history from "./utils/history";
import { UserContextProvider } from "./contexts/UserContext";
import "react-device-frameset/styles/marvel-devices.min.css";
import "react-device-frameset/styles/device-emulator.min.css";
import { BrowserRouter as Router } from "react-router-dom";
import 'swiper/css';
import 'swiper/css/pagination';
import { ContentfulContextProvider } from "./contexts/ContentfulContext";
import 'ag-grid-community/styles/ag-grid.css';
import "ag-grid-community/styles/ag-theme-quartz.css";
import "./index.css";
import App from "./App";

const { REACT_APP_AUTH0_ISSUER_BASE_URL, REACT_APP_AUTH0_CLIENT_ID } =
  process.env;

const onRedirectCallback = (appState) => {
  history.push(
    appState && appState.returnTo ? appState.returnTo : window.location.pathname
  );
};

// Register Trusted Types default policy before anything else loads scripts.
// This policy acts as a catch-all for DOM sink assignments (innerHTML, script.src, etc.)
// that third-party libraries (Stripe, TinyMCE, ag-Grid, styled-components) perform
// without native Trusted Types support.
if (window.trustedTypes && window.trustedTypes.createPolicy) {
  try {
    window.__defaultTrustedTypesPolicy = window.trustedTypes.createPolicy('default', {
    // Handles: element.innerHTML = '...', element.outerHTML = '...', insertAdjacentHTML, etc.
    createHTML: (input) => input,

    // Handles: script.text = '...', inline script content
    createScript: (input) => input,

    // Handles: script.src = '...', dynamic script loading (e.g. Stripe.js, TinyMCE)
    createScriptURL: (input) => {
      // Allow same-origin and trusted CDN URLs
      const allowedOrigins = [
        window.location.origin,
        'https://js.stripe.com',
        'https://cdn.tiny.cloud',
        'https://static.cloudflareinsights.com',
      ];
      try {
        const url = new URL(input, window.location.origin);
        if (allowedOrigins.some((origin) => url.origin === origin || url.href.startsWith(origin))) {
          return input;
        }
      } catch (e) {
        // relative URLs or malformed — allow same-origin paths
        return input;
      }
      console.warn('[TrustedTypes] Blocked script URL:', input);
      return input;
    },
  });
  } catch (e) {
    // Policy already exists, which is fine
  }
}

// const providerConfig = {
//   domain: REACT_APP_AUTH0_ISSUER_BASE_URL,
//   clientId: REACT_APP_AUTH0_CLIENT_ID,
//   onRedirectCallback,
//   authorizationParams: {
//     redirect_uri: window.location.origin,
//   },
// };

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Auth0Provider
    domain={REACT_APP_AUTH0_ISSUER_BASE_URL}
    clientId={REACT_APP_AUTH0_CLIENT_ID}
    onRedirectCallback={onRedirectCallback}
    useRefreshTokens={true}
    cacheLocation="localstorage"
    authorizationParams={{
      redirect_uri: window.location.origin,
      scope: "openid profile email",
      audience: "verify-user",
    }}
  >
    <ContentfulContextProvider>
    <Router>
        <UIProvider>
        <UserContextProvider>
            <App />
        </UserContextProvider>
        </UIProvider>
    </Router>
    </ContentfulContextProvider>
  </Auth0Provider>
);
